module.exports = __webpack_public_path__ + "static/media/Encil_01.b171f0f5.pdf";